var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 -14.553 706 706",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00d3c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.1 349.9L352.5 0 0 349.9l18.4 18.4 44.7-42.1v349.9h578.8V326.2l42.1 42.1 21.1-18.4zM405.2 649.8H299.9V439.4h105.2v210.4zm210.4 0H431.5V413.1H273.6v236.8H89.5v-350l263-263.1 263.1 263.1v349.9z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 255.2c0 44.7 34.2 78.9 78.9 78.9s78.9-34.2 78.9-78.9-34.2-78.9-78.9-78.9-78.9 34.2-78.9 78.9zm131.6 0c0 28.9-23.7 52.6-52.6 52.6S300 284.1 300 255.2s23.7-52.6 52.6-52.6 52.6 23.7 52.6 52.6z",
    vectorEffect: "non-scaling-stroke"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.02940593a3661a56495a58c0fc4daae6.svg";
export { ForwardRef as ReactComponent };